import { jsx as _jsx } from "preact/jsx-runtime";
import { createContext, useState, useContext, useMemo, } from 'preact/compat';
const MessageContext = createContext({
    messages: [],
    addMessage: (message) => null,
    removeMessage: (index) => null,
    activityReset: (activityId) => null,
    errors: [],
    warnings: [],
});
export const useMessage = () => {
    const value = useContext(MessageContext);
    return value ?? {};
};
export const MessageProvider = (props) => {
    const { children } = props;
    const [messages, setMessages] = useState([]);
    const removeMessagesForActivity = (activityId) => messages.filter((message) => message.activityId !== activityId);
    const addMessage = (message) => {
        const filteredMessages = removeMessagesForActivity(message.activityId);
        setMessages([...filteredMessages, message]);
    };
    const removeMessage = (index) => {
        setMessages(messages.filter((_, idx) => idx !== index));
    };
    const activityReset = (activityId) => {
        setMessages(removeMessagesForActivity(activityId));
    };
    const errors = useMemo(() => messages.filter((message) => message.type === 'error'), [messages]);
    const warnings = useMemo(() => messages.filter((message) => message.type === 'warning'), [messages]);
    return (_jsx(MessageContext.Provider, { value: {
            messages, addMessage, removeMessage, warnings, errors, activityReset,
        }, children: children }));
};
